import { z } from 'zod';

export const addProductSchema = z.object({
  name: z.string().min(5, { message: 'Name must be at least 5 characters' }),
  description: z.string().min(3, { message: 'Description is required' }),
  keyfeature: z.string().min(3, { message: 'Key Features is required' }),
  thumbnail: z.string().optional(),
  industry: z.string().optional(),
  categoryType: z.string().min(1, { message: 'Category type is required' }),
  category: z.string().min(1, { message: 'Category is required' }),
  subCategory: z.string().optional(),
  brand: z.string().min(1, { message: 'Brand is required' }),
  tags: z.array(z.string()).optional(),
  coupons: z.array(z.string()).optional()
});

export type AddProductSchema = z.infer<typeof addProductSchema>;

export const addCouponSchema = z.object({
  code: z.string().min(3, { message: 'Code must be at least 3 characters' }),
  discountType: z.string().min(3, { message: 'Discount type is required' }),
  value: z.preprocess(
    v => Number(v),
    z.number().positive({ message: 'Amount must be > 0' })
  ),
  validFrom: z.string().optional(),
  validTo: z.string().optional(),
  usageLimit: z
    .preprocess(
      v => (v === '' || v === undefined ? undefined : Number(v)),
      z.number().int().positive()
    )
    .optional(),

  appliesTo: z.enum([
    'all',
    'categoryType',
    'category',
    'subcategory',
    'brand',
    'product'
  ]),
  targetIds: z.array(z.string()),
  isActive: z.boolean()
});
export type AddCouponSchema = z.infer<typeof addCouponSchema>;

export const colors = {
  red: '#FF0000',
  blue: '#0000FF',
  green: '#00FF00',
  yellow: '#FFFF00',
  purple: '#800080',
  orange: '#FFA500',
  pink: '#FFC0CB',
  white: '#FFFFFF',
  black: '#000000',
  darkgreen: '#006400',
  darkblue: '#000080',
  darkred: '#800000',
  darkyellow: '#808000',
  darkpurple: '#800080',
  darkorange: '#FF8C00',
  darkpink: '#FF1493',
  darkwhite: '#F0F0F0',
  darkblack: '#202020',
  darkgray: '#808080',
  darkbrown: '#A52A2A',
  darkgold: '#DAA520',
  darksilver: '#C0C0C0',
  magenta: '#FF00FF',
  cyan: '#00FFFF',
  lime: '#00FF00',
  maroon: '#800000',
  olive: '#808000',
  navy: '#000080',
  teal: '#008080',
  silver: '#C0C0C0',
  gold: '#FFD700',
  bronze: '#CD7F32',
  gray: '#808080',
  brown: '#A52A2A',
  beige: '#F5F5DC',
  khaki: '#F0E68C',
  mint: '#98FF98',
  lavender: '#E6E6FA'
};

export const sizes = {
  xs: 'Extra Small',
  sm: 'Small',
  md: 'Medium',
  lg: 'Large',
  xl: 'Extra Large',
  xxl: 'Extra Extra Large',
  small: 'Small',
  medium: 'Medium',
  large: 'Large'
};

export const weights = {
  lb: 'Pounds',
  kg: 'Kilograms',
  g: 'Grams',
  mg: 'Milligrams',
  oz: 'Ounces',
  gr: 'Grams'
};
